// Base Imports
import React from "react";

// Component Imports
import FloatingLabelFormField from "./FloatingLabelFormField";

// Other Imports
import { matchStrings } from "@framework/utils/parse-util";


const DEFAULT_TYPES = ["text", "number", "tel", "date"];

const ProfileFormField = ({
    key,
    context,
    item,
    extraConfig,
    lastChildInFloatingContainer,
}: any) => {

    return (
        <>
            {
                DEFAULT_TYPES.includes(item?.type) && (
                    <FloatingLabelFormField
                        key={key}
                        context={context}
                        item={item}
                        extraConfig={extraConfig}
                        lastChildInFloatingContainer={lastChildInFloatingContainer}
                    />
                )
            }

        </>
    );
};

export default ProfileFormField;